import React from "react";
import {Redirect, Route, RouteProps} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores/useStores";
import {RoutePaths} from "../../shared/routePaths";
import {AuthUser} from "./user";

/**
 * Route wrapper that restricts access to super users (SuperAdmin/Office roles).
 * Non-super users are redirected to the AccessDenied page. Unauthenticated users
 * fall through to the sign-in redirect used elsewhere in the app.
 */
const SuperUserRoute: React.FC<
  RouteProps & {component: React.ComponentType<any>}
> = ({component: Component, ...rest}) => {
  const {
    uiStore: {accountStore}
  } = useStores();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!accountStore.isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: RoutePaths.SignIn,
                state: {from: props.location}
              }}
            />
          );
        }
        if (!AuthUser.getInstance().IsSuperUser) {
          return (
            <Redirect
              to={{
                pathname: RoutePaths.AccessDenied,
                state: {from: props.location}
              }}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default observer(SuperUserRoute);
